module.exports = "<div class=\"jumbotron\">\n  <div class=\"container\">\n    <h1 class=\"display-3\">Something Went Wrong</h1>\n  </div>\n</div>\n\n<h4>\n  Something went very wrong!\n</h4>\n<p>\n  Sorry about that! You can try again or something is permanently broken.\n</p>\n"


//////////////////
// WEBPACK FOOTER
// D:/Development/Angular/grim3212.com/src/app/containers/error-pages/something-wrong/something-wrong.component.html
// module id = ../../../../../src/app/containers/error-pages/something-wrong/something-wrong.component.html
// module chunks = main